exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* breadcrumbs */\nul.aui-breadcrumbs__container {  \n  display: flex;\n  flex-wrap: wrap;\n}\nli.aui-breadcrumbs__item{  \n  margin: 2px 0 4px 4px;\n  font-size: 14px;\n  display: flex;\n  align-items: baseline; \n}\n\nli.aui-breadcrumbs__item a{\n  color: #777;\n}\n\nli.aui-breadcrumbs__item a:hover {\n  color: #23527c;\n}\n\nli.aui-breadcrumbs__item i.glyphicon {\n  font-size: 12px;\n  margin-right:4px;\n  color: #bbb;  \n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/js/components/breadcrumbs/breadcrumbs.css
// module id = 28
// module chunks = 1